import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import CalcSection from './CalcSection'
import CalcParagraph from './CalcParagraph'
import NavBtn from './NavBtn'
import NavBar from './NavBar'
import {
  basicsAggregateSelector,
  extrasAggregateSelector,
  freedomAggregateSelector
} from '../../redux/selectors'
import LabeledRowOutput from '../forms/LabeledRowOutput'
import { formWrapperStyle } from '../forms/form'
import HelpFilter from './HelpFilter'
import { formatWithCommas } from '../foundation/number'

/**
 * Smart component for rendering Section 4 of the calculator
 */
class Section4 extends Component {
  /**
   * Render component
   */
  render () {
    return (
      <CalcSection title={this.props.title}>
        <CalcParagraph>
          <HelpFilter showLevel={[1, 2]}>
            If you have put some time and effort into each of your answers so
            far, congratulations - you are taking ownership of your future and
            you should feel great about that!
          </HelpFilter>{' '}
          Below are the total, aggregated, per-month values you've entered so
          far.
          <HelpFilter showLevel={[1, 2]}>
            These numbers represent your monthly income need for each of the
            three scenarios. You are free to go back and adjust the numbers as
            you see fit but, again, if you put effort in the first time around,
            I'd encourage you to stick with your first answer.
          </HelpFilter>
        </CalcParagraph>
        <div style={formWrapperStyle}>
          <LabeledRowOutput
            label='The Basics'
            output={formatWithCommas(this.props.basicsAggregate)}
          />
          <LabeledRowOutput
            label='Basics + Extras'
            output={formatWithCommas(this.props.extrasAggregate)}
          />
          <LabeledRowOutput
            label='Financial Freedom!'
            output={formatWithCommas(this.props.freedomAggregate)}
          />
        </div>
        <CalcParagraph>
          If you are happy with your monthly cost estimates then we will move on
          to the "Assets" sections.
          <HelpFilter showLevel={[1, 2]}>
            This is where you will enter things like what savings you have
            toward retirement, income streams you may be counting on in
            retirement and key assumptions such as rate of return on savings,
            social security income, etc.
            <HelpFilter showLevel={[1]}>
              Don't worry if some of this appears overwhelming - just like a
              clock made of many springs, gears and pulleys, the pieces are
              simple when we break the clock down to it's constituent pieces.
              And we will continue to do so just like we did through the Monthly
              Costs sections. So let's go!
            </HelpFilter>
          </HelpFilter>
        </CalcParagraph>
        <NavBar>
          <NavBtn nextSection={3} back />
          <NavBtn nextSection={5} />
        </NavBar>
      </CalcSection>
    )
  }
}

Section4.propTypes = {
  title: PropTypes.string.isRequired
}

export function mapStateToProps (state) {
  return {
    basicsAggregate: basicsAggregateSelector(state),
    extrasAggregate: extrasAggregateSelector(state),
    freedomAggregate: freedomAggregateSelector(state)
  }
}

export default connect(mapStateToProps)(Section4)



// WEBPACK FOOTER //
// ./src/components/sections/Section4MonthlyCosts.js